<template>
  <div v-if="isOpen">
    <!-- BACKDROP -->
    <div class="spx-modal-background" @click="close"></div>

    <!-- MODAL WRAPPER -->
    <div class="spx-modal d-flex justify-content-center align-items-center">
      <div class="team-executive-modal">
        <!-- HEADER -->
        <div class="team-modal-header d-flex justify-content-between align-items-center">
          <!-- LEFT : EXECUTIVE INFO -->
          <div class="d-flex align-items-center">
            <!-- PROFILE IMAGE -->
            <img
              class="team-exec-avatar"
              :src="currentExecutiveLogo"
              alt="logo"
              style="width: 60px; height: 60px; border-radius: 50%; object-fit: contain;"
            />

            <!-- NAME + COUNT -->
            <div class="ml-3">
              <div class="team-exec-name">
                {{ currentExecutiveName }}
              </div>
            </div>

            <!-- 🔥 VERTICAL LINE -->
            <div class="name-suggestion-divider"></div>
            <div class="ai-suggestion-box mt-1">
              <div v-if="currentExecutive.is_duplicate_executive">
                <span class="ai-label">A duplicate executive name was found.</span>
              </div>
              <div v-if="currentExecutive.job_function_suggestion_message">
                <span class="ai-label">Possible job function matches:</span>
                <strong>{{ currentExecutive.job_function_suggestion_message }}</strong>
              </div>

              <div v-if="currentExecutive.industry_suggestion_message">
                <span class="ai-label">Possible industry matches:</span>
                <strong>{{ currentExecutive.industry_suggestion_message }}</strong>
              </div>

              <div v-if="currentExecutive.seniority_suggestion_message">
                <span class="ai-label">Possible seniority matches:</span>
                <strong>{{ currentExecutive.seniority_suggestion_message }}</strong>
              </div>

              <div v-if="currentExecutive.country_suggestion_message">
                <span class="ai-label">Possible country matches:</span>
                <strong>{{ currentExecutive.country_suggestion_message }}</strong>
              </div>

              <div v-if="currentExecutive.company_suggestion_message">
                <span class="ai-label">Possible company matches:</span>
                <strong>{{ currentExecutive.company_suggestion_message }}</strong>
              </div>

              <div v-if="currentExecutive.job_title_suggestion_message">
                <span class="ai-label">Possible job title matches:</span>
                <strong>{{ currentExecutive.job_title_suggestion_message }}</strong>
              </div>            
            </div>

          </div>

          <div class="ai-info-wrapper spx-modal-close" @click.stop>
            <span class="ai-info-btn" @click="toggleInfo">ℹ️</span>

            <div v-if="showInfo" class="ai-info-popup">

              <!-- 🔥 HEADER IMAGE -->
              <div class="ai-popup-header">
                <img
                  :src="currentShowOnUi.ImageUrl || '/img/user-pic.png'"
                  alt="profile"
                  class="ai-popup-avatar"
                />
              </div>

              <!-- 🔥 EXISTING DETAILS (UNCHANGED) -->
              <div
                v-for="(value, key) in currentShowOnUi"
                :key="key"
                class="ai-info-row"
              >
                <strong>{{ key }}</strong> {{ value }}
              </div>

            </div>
            <button type="button" class="spx-modal-close" @click="close">✕</button>
          </div>
          <!-- CLOSE -->
        </div>

        <!-- BODY -->
        <div class="team-executive-content">
          <!-- 🔽 YOUR COMPLETE FORM GOES HERE (UNCHANGED) -->
           <!-- <AddExecutive ref="addExecutiveRef" :team-executive="executives[currentIndex]" :isTeamExecutivePopup="true" @created="onExecutiveCreated" /> -->
          <AddExecutive
            :key="currentIndex"
            ref="addExecutiveRef"
            :team-executive="executives[currentIndex]"
            :isTeamExecutivePopup="true"
            @created="onExecutiveCreated"
          />
        </div>

        <!-- FOOTER -->
        <div class="team-popup-footer">
          <!-- 🔹 CENTER COUNTER -->
          <div class="team-exec-counter">
            Team Executive {{ currentIndex + 1 }} / {{ executives.length }}
          </div>

          <!-- 🔹 RIGHT ACTIONS -->
          <div class="team-exec-actions">
            <button
              class="fil-btn mr-2"
              :disabled="currentIndex === 0"
              @click="prev">
              Previous
            </button>

            <button
              class="fil-btn"
              :disabled="currentIndex === executives.length - 1"
              @click="next">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ErrorComponent from "@/components/ErrorComponent";
// import TextModal from "@/components/TextModal";
// import PhoneCode from "@/components/PhoneCodePicker/PhoneCode";
// import { Form, Field, ErrorMessage } from "vee-validate";
// import Datepicker from "@vuepic/vue-datepicker";
// import ImagePicker from "@/components/ImagePicker.vue";
import "@vuepic/vue-datepicker/dist/main.css";
// import Multiselect from "@vueform/multiselect";
import AddExecutive from "../views/Manage-Executive/add-executive.vue";


export default {
  name: "TeamExecutiveModal",

  components: {
    // Form,
    // // TextModal,
    // Field,
    // // ErrorComponent,
    // Multiselect,
    // Datepicker,
    // // ImagePicker,
    // ErrorMessage,
    // PhoneCode,
    AddExecutive
  },

  props: {
    teamPageUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentExecutive() {
      return this.executives[this.currentIndex] || {};
    },

    currentExecutiveName() {
      return this.currentExecutive.executive_name || "Unnamed Executive";
    },

    currentExecutiveLogo() {
      return (this.currentExecutive.executive_logo || "/img/user-pic.png");
    },

    // 🔥 ADD THIS ONLY
    currentShowOnUi() {
      const showOnUi = this.$shareService.getMapValue("team_ai_executives_show_on_ui");
      if (!showOnUi) return {};
      return showOnUi[this.currentIndex] || {};
    }    
  },
  data() {
    return {
      isOpen: false,
      showInfo: false,

      executives: [],
      currentIndex: 0,
      detail: {},

      // 🔥 IMPORTANT: PREVENT undefined
      companyList: [],
      executiveList: [],
      executiveList2: [],
      jobTitleList: [],
      jobFunctionList: [],
      industryList: [],
      senioritylevelList: [],
      countryList: [],
      cityList: [],
      cityPastList: [],
      regionList: [],
      segmentList: [],
      subsectorsList: [],
      aagerangeList: [],
    };
  },

  methods: {
    toggleInfo() {
      this.showInfo = !this.showInfo;
    },    
    // onExecutiveCreated({ index, id }) {
    //   if (!index) index = this.currentIndex;
    //   this.executives[index].id = id;
    // },
    onExecutiveCreated({ detail }) {
      console.log('onExecutiveCreated- curr-index-', JSON.stringify(this.currentIndex), 'detail-', JSON.stringify(detail));
      
      // 🔥 Replace AI executive with REAL saved executive
      this.executives.splice(this.currentIndex, 1, {
        ...this.executives[this.currentIndex], // preserve AI fields
        ...detail,                              // saved DB fields
        id: detail.id,                          // 🔥 ensure id is kept
        _source: "db",
      });
      // this.currentIndex = replaceIndex;
    },  

    /* 🔓 OPEN MODAL */
    open() {      
      // 🔥 READ FROM SHARED SERVICE
      const data = this.$shareService.getMapValue("team_ai_executives");

      if (!data?.length) return;

      this.executives = data;
      this.currentIndex = 0;
      this.isOpen = true;

      this.extractSelectedIdsFromExecutive(this.executives[this.currentIndex]);
    },

    /* ❌ CLOSE MODAL */
    close() {
      this.isOpen = false;
      this.executives = [];
      this.currentIndex = 0;

      // 🔥 CLEAN UP
      this.$shareService.getMapValueAndRemove("team_ai_executives");
    },

    /* ➡ NEXT */
    next() {
      if (this.currentIndex >= this.executives.length - 1) return;

      this.showInfo = false;
      this.currentIndex++;
      console.log(' next- ', JSON.stringify(this.executives[this.currentIndex]));
      
      // this.detail = this.executives[this.currentIndex];

      // this.extractSelectedIdsFromExecutive(this.detail);
      this.extractSelectedIdsFromExecutive(this.executives[this.currentIndex]);

    },

    /* ⬅ PREVIOUS */
    prev() {
      
      if (this.currentIndex === 0) return;
      this.showInfo = false;
      this.currentIndex--;
      console.log(' prev- ', JSON.stringify(this.executives[this.currentIndex]));
      // this.detail = this.executives[this.currentIndex];

      // this.extractSelectedIdsFromExecutive(this.detail);

      this.extractSelectedIdsFromExecutive(this.executives[this.currentIndex]);
    },

    extractSelectedIdsFromExecutive(exec) {
      
      if (!exec) return;

      this.$nextTick(() => {
        const child = this.$refs.addExecutiveRef;
        if (!child || !child.runDropdownListWithSelectedIds) return;

        const companyIds = [];
        if (exec.new_company_id) companyIds.push(exec.new_company_id);
        if (exec.prev_company_id) companyIds.push(exec.prev_company_id);
        if (companyIds.length) {
          child.runDropdownListWithSelectedIds(companyIds, 'COMPANY');
        }

        if (exec.industry_id_new) {
          child.runDropdownListWithSelectedIds([exec.industry_id_new], 'INDUSTRY');
        }

        if (exec.country_id_new) {
          child.runDropdownListWithSelectedIds([exec.country_id_new], 'CURRENT_COUNTRY_CHANGE');
        }

        if (exec.country_id_prev) {
          child.runDropdownListWithSelectedIds([exec.country_id_prev], 'PAST_COUNTRY_CHANGE');
        }
        
        // Don't need to do for this becuase in backend listing api dont have limit
        // if (exec.job_function_id_new) {
        //   child.runDropdownListWithSelectedIds([exec.job_function_id_new], 'JOB_FUNCTION');
        // }

        // if (exec.seniority_id) {
        //   child.runDropdownListWithSelectedIds([exec.seniority_id], 'SENIORITY_LEVEL');
        // }

        // if (exec.country_id) {
        //   child.runDropdownListWithSelectedIds([exec.country_id], 'COUNTRY');
        // }

        // if (exec.new_job_title_id) {
        //   child.runDropdownListWithSelectedIds([exec.new_job_title_id], 'JOB_TITLE');
        // }
      });
    },    
  },
};
</script>

<style scoped>
/* BACKDROP */
.spx-modal-background {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}

/* CENTER WRAPPER */
.spx-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;

  display: flex;
  align-items: center;     /* 🔥 vertical center */
  justify-content: center; /* 🔥 horizontal center */
}

/* MAIN MODAL */
.team-executive-modal {
  width: 95vw;
  max-width: 1800px;

  height: 90vh;
  max-height: 95vh;

  background: #fff;
  border-radius: 10px;

  display: flex;
  flex-direction: column;
}

.team-exec-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  object-fit: cover;
  /* border: 2px solid #ddd; */
  background: #fff;
}

.team-exec-name {
  font-weight: 600;
  font-size: 15px;
}

/* BODY SCROLL */
.team-executive-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* HEADER */
.team-modal-header {
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
}

.team-popup-footer {
  position: relative;              /* 🔥 required for centering */
  padding: 16px;
  border-top: 1px solid #eee;

  display: flex;
  align-items: center;
}

/* CENTER TEXT */
.team-exec-counter {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

/* RIGHT BUTTONS */
.team-exec-actions {
  margin-left: auto;
  display: flex;
}


/* CLOSE BUTTON */
.spx-modal-close {
  font-size: 22px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.ai-suggestion-box {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.5;
  margin-top: 4px;
}

.ai-suggestion-box > div {
  white-space: nowrap;
}

.ai-label {
  font-weight: 500;
  margin-right: 4px;
  /* font-style: italic; */
}
.name-suggestion-divider {
  width: 1px;
  height: 70px;            /* adjust as needed */
  background-color: #ddd;
  margin: 0 12px;
}
.ai-info-wrapper {
  position: relative;
  margin-left: 8px;
}

.ai-info-btn {
  cursor: pointer;
  font-size: 20px;
}

.ai-info-popup {
  position: absolute;
  top: 32px;
  right: 0;

  width: 40vw;              /* 🔥 50% of screen width */
  max-width: 500px;         /* 🔥 never exceed this */
  min-width: 320px;         /* 🔥 safe minimum for small screens */

  max-height: 65vh;         /* 🔥 responsive height */
  overflow-y: auto;

  background: #fff;
  border: 1px solid #ddd;
  padding: 16px;
  font-size: 10px;
  line-height: 1.4;

  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);

  z-index: 9999;
}
.ai-popup-header {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.ai-popup-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: contain;
  background: #f5f5f5;
}
.ai-info-row {
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.ai-info-row:last-child {
  border-bottom: none;
}
.ai-info-row {
  display: flex;
  gap: 6px;
}

.ai-info-row strong {
  min-width: 100px;
  font-weight: 600;
  color: #000;
}
</style>
